var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.295 14.2437C17.8225 14.705 17.5525 15.3687 17.62 16.0775C17.7213 17.2925 18.835 18.1812 20.05 18.1812H22.1875V19.52C22.1875 21.8487 20.2862 23.75 17.9575 23.75H5.0425C2.71375 23.75 0.8125 21.8487 0.8125 19.52V11.9488C0.8125 9.62001 2.71375 7.71875 5.0425 7.71875H17.9575C20.2862 7.71875 22.1875 9.62001 22.1875 11.9488V13.5688H19.915C19.285 13.5688 18.7113 13.8162 18.295 14.2437Z",
    stroke: "#001860",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 12.9612V7.82006C0.8125 6.48131 1.63375 5.28876 2.8825 4.81626L11.815 1.44126C13.21 0.912507 14.7063 1.94754 14.7063 3.44379V7.71878",
    stroke: "#001860",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d01b70ad.svg";
export { ForwardRef as ReactComponent };